export var ModalCloseTypes;
(function (ModalCloseTypes) {
    ModalCloseTypes["KEY_DOWN"] = "escapeKeyDown";
    ModalCloseTypes["BACKDROP_CLICK"] = "backdropClick";
})(ModalCloseTypes || (ModalCloseTypes = {}));
//# sourceMappingURL=ModalCloseTypes.js.map